module.exports = __webpack_public_path__ + "img/gw1.7dcf97e4.png";